import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  cleanUpCollectionPointDetail,
  getCollectionPointDetailThunk,
} from "../../../../reducers/collectionPointReducer";
import { buildCollectionPointUrl } from "../../../../utils/url";

export const useGetWagonsReportTableHandlers = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const openLocationDetail = (locationId: number) => {
    dispatch(cleanUpCollectionPointDetail());
    dispatch(getCollectionPointDetailThunk(locationId));

    history.push(buildCollectionPointUrl(locationId));
  };

  return {
    openLocationDetail,
  };
};
